<template>
  
  <div class="sixteen wide column">
    <div class="ui segment">
      <h4 class="ui dividing header">Totais do Orçamento</h4>
      <form class="ui form">
        <div class="fields">
          <div class="three wide field">
            <label class="form-label">Total Sugerido</label>
            <input type="text" :value="'R$ ' + $formatCurrency(quotation.sugTotal)" readonly="readonly">
          </div>
          <div class="three wide field">
            <label class="form-label">
              Total Aprovado 
              <i v-if="quotation.sugTotal > quotation.appTotal" class="exclamation circle red icon"></i>
              <i v-else class="check circle green icon"></i>
            </label>
            <input type="text" :value="'R$ ' + $formatCurrency(quotation.appTotal)" readonly="readonly">
          </div>
          <div class="three wide field">
            <label class="form-label">Metragem Total</label>
            <input type="text" :value="$formatInteger(quotation.totalMeters)" readonly="readonly">
          </div>
          <div class="three wide field">
            <label class="form-label">
              % Flex 2,5mm2 
              <i v-if="quotation.hasFlexAlert" class="exclamation circle red icon"></i>
              <i v-else class="check circle green icon"></i>
            </label>
            <input type="text" :value="$formatCurrency(quotation.flexPerc)" readonly="readonly">
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script>

  export default {
    
    props: ["quotation"],
  }
</script>

